import { ActionContext, Module } from 'vuex'
import { AiLocationState, RootState } from '../store/state_models'

import { AiWrapperService } from '../services'
import { awaitToJS } from '@/util/await-to-js'
import { locations } from './location'
import { company } from './company'


export const aiLocationPlan: Module<AiLocationState, RootState> = {
  namespaced: true,
  state: {
    isSeasonOfAIOptIn: undefined,
    plan: undefined,
    isSOADisabled: undefined,
    seasonOfAI: undefined,
    showSummerOfAIMenu: undefined,
    locationPlans: {},
    locationSeasonOfAI: {},
    locationOptIn: {},
    locationProductEnabled: {},
    locationShowMenu: {}
  },
  getters: {
    getSOAOptIn: (state: AiLocationState, getters: any, rootState: RootState) => {
      const currentLocation = locations?.state?.currentLocation?.id
      return currentLocation ? state.locationOptIn[currentLocation] : undefined
    },
    getProductEnabled: (state: AiLocationState, getters: any, rootState: RootState) => {
      const currentLocation = locations?.state?.currentLocation?.id
      return currentLocation ? state.locationProductEnabled[currentLocation] : undefined
    },
    getPlan: (state: AiLocationState, getters: any, rootState: RootState) => {
      const currentLocation = locations?.state?.currentLocation?.id
      return currentLocation ? state.locationPlans[currentLocation] : undefined
    },
    getShowSummerOfAIMenu: (state: AiLocationState, getters: any, rootState: RootState) => {
      const currentLocation = locations?.state?.currentLocation?.id
      // console.log('DIV getShowSummerOfAIMenu', currentLocation)
      // console.log('DIV getShowSummerOfAIMenu locationShowMenu', state.locationShowMenu)
      return false
      const isSummerOfAINotOptedInFromLocalStorage = localStorage.getItem('summerofai') === 'false';
      if(isSummerOfAINotOptedInFromLocalStorage) {
        return false
      }
      return currentLocation ? state.locationShowMenu[currentLocation] : undefined
    },
    getSeasonOfAI: (state: AiLocationState, getters: any, rootState: RootState) => {
      const currentLocation = locations?.state?.currentLocation?.id
      return currentLocation ? state.locationSeasonOfAI[currentLocation] : undefined
    }
  },
  mutations: {
    setIsOptIn: (state: AiLocationState, payload: boolean) => {
      const currentLocation = locations?.state?.currentLocation?.id
      if (currentLocation) {
        state.locationOptIn[currentLocation] = payload
      }
    },
    setPlan: (state: AiLocationState, payload: any) => {
      const currentLocation = locations?.state?.currentLocation?.id
      if (currentLocation) {
        state.locationPlans[currentLocation] = payload
      }
    },
    setSeasonOfAI: (state: AiLocationState, payload: any) => {
      const currentLocation = locations?.state?.currentLocation?.id
      if (currentLocation) {
        const isSOADisabled = (payload?.disableSummarOfAI) || false
        state.locationSeasonOfAI[currentLocation] = payload
      }
    },
    setProductEnabled: (state: AiLocationState, payload: boolean) => {
      const currentLocation = locations?.state?.currentLocation?.id
      if (currentLocation) {
        state.locationProductEnabled[currentLocation] = payload
      }
    },
    setShowSummerOfAIMenu: (state: AiLocationState, payload: boolean) => {
      const currentLocation = locations?.state?.currentLocation?.id
      // console.log('DIV setShowSummerOfAIMenu', payload)
      // console.log('DIV setShowSummerOfAIMenu currentLocation', currentLocation)
      if (currentLocation) {
        // console.log('DIV setShowSummerOfAIMenu', currentLocation, payload)
        state.locationShowMenu[currentLocation] = payload
      }
    },
  },
  actions: {
    fetchShowSummerOfAIMenu: async (
      context: ActionContext<AiLocationState, RootState>,
      payload: {
        locationId: string
      }
    ) => {
      const locationId = payload.locationId;
      // console.log('HARISH handleSeasonOfAIAgentLocation locationId ', locationId)
      if (!locationId) return;

      const companyStatus = company?.state?.company?.status;
      console.log('handleSeasonOfAIAgentLocation companyStatus', companyStatus)

      const isTrial = companyStatus !== 'active' || companyStatus === 'active_trial' || companyStatus === 'active_trial-extension'

      // Check if we already have cached data
      const showMenu = context.state?.locationShowMenu[locationId];
      if (showMenu !== undefined && showMenu !== null) {
        // console.log('HARISH handleSeasonOfAIAgentLocation showMenu cached returned', showMenu)
        return showMenu;
      }

      const [err, response] = await awaitToJS(AiWrapperService.isSummerOfAIOptinForLocation(locationId, {}));
      if (err) {
        return;
      }

      const isSubscription = response?.plan.type === 'SUBSCRIPTION' && response?.plan?.subscriptionId;
      const isSummerOfAIOptedIn = response?.summerOfAI?.optedInAt;
      const disableSummarOfAI = response?.summerOfAI?.disableSummarOfAI;
      const dontShowMenu = isSubscription && !isSummerOfAIOptedIn;
      const productEnabled = response?.productEnabled;
      // const isSummerOfAINotOptedInFromLocalStorage = localStorage.getItem('summerofai') === 'false';
      const isSummerOfAINotOptedInFromLocalStorage = true;
      const shouldShowMenu = !dontShowMenu && !disableSummarOfAI && productEnabled && !isTrial && !isSummerOfAINotOptedInFromLocalStorage;
      

      // Update all related state
      context.commit('setPlan', response?.plan || {});
      context.commit('setSeasonOfAI', response?.summerOfAI || {});
      // Check localStorage for summerofai value
      let summerOfAIOptIn = false;
      try {
        const summerOfAI = localStorage.getItem('summerofai');
        if (summerOfAI === 'false') {
          summerOfAIOptIn = false;
        } else {
          summerOfAIOptIn = !!response?.optIn;
        }
      } catch (e) {
        summerOfAIOptIn = !!response?.optIn;
      }

      summerOfAIOptIn = false;
      context.commit('setIsOptIn', summerOfAIOptIn);
      context.commit('setShowSummerOfAIMenu', shouldShowMenu);
      context.commit('setProductEnabled', productEnabled);
      // console.log('HARISH handleSeasonOfAIAgentLocation shouldShowMenu non cached returning', shouldShowMenu)
      // console.log('HARISH handleSeasonOfAIAgentLocation response non cached', response)
      // console.log('HARISH handleSeasonOfAIAgentLocation context.state non cached', context.state)
      // console.log('HARISH handleSeasonOfAIAgentLocation context.state.locationShowMenu non cached', context.state.locationShowMenu)
      // console.log('HARISH handleSeasonOfAIAgentLocation context.state.locationShowMenu[locationId] non cached', context.state.locationShowMenu[locationId])        
      return shouldShowMenu;
    },
    syncAll: async (
      context: ActionContext<AiLocationState, RootState>,
      payload: {
        locationId: string,
        routePathParams: any
      }
    ) => {
      if (!payload.locationId) return

      const companyStatus = company?.state?.company?.status;
      console.log('handleSeasonOfAIAgentLocation companyStatus', companyStatus)

      const isTrial = companyStatus !== 'active' || companyStatus === 'active_trial' || companyStatus === 'active_trial-extension'


      // Check if we already have the data for this location
      const existingPlan = context.state.locationPlans[payload.locationId];
      const existingSeasonOfAI = context.state.locationSeasonOfAI[payload.locationId];
      const existingOptIn = context.state.locationOptIn[payload.locationId];
      const existingShowMenu = context.state.locationShowMenu[payload.locationId];
      
      if (existingPlan !== undefined && existingSeasonOfAI !== undefined && 
          existingOptIn !== undefined && existingShowMenu !== undefined) {
            console.log(' handleSeasonOfAIAgentLocation going with existing data', payload.locationId)
            console.log('handleSeasonOfAIAgentLocation existingPlan', existingPlan)
            console.log('handleSeasonOfAIAgentLocation existingSeasonOfAI', existingSeasonOfAI)
            console.log('handleSeasonOfAIAgentLocation existingOptIn', existingOptIn)
            console.log('handleSeasonOfAIAgentLocation existingShowMenu', existingShowMenu)
        return {
          plan: existingPlan,
          seasonOfAI: existingSeasonOfAI,
          isOptIn: existingOptIn,
          showMenu: existingShowMenu
        };
      }
      // console.log('going with new data', payload.locationId)

      try {
        const [err, response] = await awaitToJS(AiWrapperService.isSummerOfAIOptinForLocation(payload.locationId,{}))
        if (err) {
          return
        }

        const isSubscription = response?.plan.type === 'SUBSCRIPTION' && response?.plan?.subscriptionId
        const isSummerOfAIOptedIn = response?.summerOfAI?.optedInAt
        const disableSummarOfAI = response?.summerOfAI?.disableSummarOfAI
        
        const dontShowMenu = isSubscription && !isSummerOfAIOptedIn
        const productEnabled = response?.productEnabled;
        
        const showMenu = !dontShowMenu && !disableSummarOfAI && productEnabled && !isTrial;
        // console.log(' handleSeasonOfAIAgentLocation DIV showMenu', showMenu)
        // console.log(' handleSeasonOfAIAgentLocation DIV isSubscription', isSubscription)
        // console.log(' handleSeasonOfAIAgentLocation DIV isSummerOfAIOptedIn', isSummerOfAIOptedIn)
        // console.log(' handleSeasonOfAIAgentLocation DIV disableSummarOfAI', disableSummarOfAI)
        // console.log(' handleSeasonOfAIAgentLocation DIV dontShowMenu', dontShowMenu)

        if(response && response.plan) {
          context.commit('setPlan', response.plan)
        }
        if(response && response.summerOfAI) {
          context.commit('setSeasonOfAI', response.summerOfAI)
        }


        context.commit('setIsOptIn', showMenu)
        context.commit('setShowSummerOfAIMenu', showMenu)
      } catch (err) {
        console.log('err', err)
        context.commit('setIsOptIn', false)
        context.commit('setShowSummerOfAIMenu', false)
      }
    },
    updatePlanConfig: (
      context: ActionContext<AiLocationState, RootState>, 
      payload: { isSeasonOfAIOptIn: boolean, plan: any }
    ) => {
      context.commit('setIsOptIn', payload.isSeasonOfAIOptIn)
      context.commit('setPlan', payload.plan)
      context.commit('setShowSummerOfAIMenu', payload.isSeasonOfAIOptIn)
    }
  },
}